import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Sparkles } from 'lucide-react';
import { useSubscription } from '../../hooks/useSubscription';

export const TrialBanner: React.FC = () => {
  const { isTrialing, trialDaysLeft, subscription } = useSubscription();
  const [dismissed, setDismissed] = useState(false);

  const devBanner = import.meta.env.DEV
    && new URLSearchParams(window.location.search).get('devBanner') === '1';

  if (!devBanner && (!isTrialing || subscription || trialDaysLeft > 3 || dismissed)) {
    return null;
  }

  return (
    <div className="mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-4 py-3 rounded-xl bg-amber-500/10 border border-amber-500/30">
      <div className="flex items-center gap-3 min-w-0">
        <Sparkles className="w-4 h-4 text-amber-400 flex-shrink-0" />
        <p className="text-sm text-amber-200">
          Seu periodo de teste expira em{' '}
          <strong>{trialDaysLeft} {trialDaysLeft === 1 ? 'dia' : 'dias'}</strong>.
          Assine agora para continuar usando.
        </p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <Link
          to="/pricing"
          className="min-h-[44px] sm:min-h-0 px-3 py-3 sm:py-1.5 rounded-lg bg-amber-500 text-neutral-950 text-sm font-medium hover:bg-amber-400 transition-colors"
        >
          Ver planos
        </Link>
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dispensar banner"
          className="p-3 sm:p-1 rounded-lg text-amber-400 hover:text-amber-300 hover:bg-amber-500/20 transition-colors"
        >
          <X className="w-5 h-5 sm:w-4 sm:h-4" />
        </button>
      </div>
    </div>
  );
};
